module.exports = __webpack_public_path__ + "static/logo-7665f742d9402c726ad0cd313e098ef8.svg";